import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './styles/global.css'
import '@/styles/index.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/element-variables.scss'

import * as _filter from './filters/index'
import '@/styles/index.css'

import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueAMap from 'vue-amap'
import permission from '@/directive/permission'
import './SDK/SDK_CallBack' // 注册SDK回调事件，并且将事件发布到vue实例中

Object.keys(_filter).forEach(item => {
  Vue.filter(item, _filter[item])
})
Vue.use(VueQuillEditor)

Vue.use(ElementUI)
Vue.use(VueAMap)
// 注册按钮权限 自定义指令
Vue.use(permission)
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: '747f980f217a31ba68d99301045a3fa7', // 这里写你申请的高德地图的key可以去https://console.amap.com/申请key
  plugin: ['AMap.Autocomplete', 'AMap.Geocoder', 'AMap.Geolocation'],
  v: '1.4.15',
  uiVersion: '1.1'
})
// 添加SDK的容器指令，创建虚拟DOM后可通知指令的方式直接在虚拟DOM里添加HTML元素
Vue.directive('SDKVideo', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted (el, { value, modifiers }) {
    if (modifiers.user) {
      // 添加成员视图容器
      const { UID, camId } = value
      const userVideoObj = window.CRVideo_CreatVideoObj() // 创建视频对象
      userVideoObj.setVideo(UID, camId) // 设置显示成员摄像头画面,camId为undefined时则订阅默认摄像头
      userVideoObj.dblClickFullScreen(true) // 设置双击全屏
      // 创建SDK视频对象，并挂载到DOM上
      el.appendChild(userVideoObj.handler()) // 将组件DOM放到页面上
    } else if (modifiers.screen) {
      // 插入屏幕共享视频容器
      const screenObj = window.CRVideo_CreatScreenShareObj() // SDK主调接口：创建屏幕共享容器
      screenObj.setVideo(value) // setVideo后才会显示内容
      console.log(screenObj.handler())
      const dom = screenObj.handler()
      dom.getElementsByTagName('video')[0].controls = true
      el.appendChild(dom) // 将组件DOM放到页面上
    } else if (modifiers.media) {
      // 插入影音共享视频容器
      const { shareUID, curPlayFile } = value
      const mediaObj = window.CRVideo_CreatMediaObj() // SDK通知接口：创建影音共享播放容器
      if (curPlayFile) {
        window.CRVideo_StartPlayMedia(mediaObj, curPlayFile) // SDK通知接口：开始播放影音共享
      }
      mediaObj.setVideo(shareUID) // setVideo后才会显示视频
      el.appendChild(mediaObj.handler()) // 将组件DOM放到页面上
    }
  }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
